import React from 'react';

import { Alert, AlertHeading, AlertMessage, Button } from '@components/common';

import { AlertProps } from '../types';

export const EditScheduledEvents: React.FC<React.PropsWithChildren<AlertProps>> = () => (
  <Alert className='my-4' type='promo' dismissKey='edit-scheduled-events-alert'>
    <AlertHeading>Edit scheduled events within Great Question</AlertHeading>
    <AlertMessage>
      Instead of editing events in your own calendar, find the ability to edit scheduled events in the{' '}
      <em>Booking details</em> section of the participant profile.
    </AlertMessage>
  </Alert>
);
